export enum CRMAccountType {
    Account = 1,
    Lead = 2,
    Contact = 3,
    Opportunity = 4
}
